const Single = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Shippings/Single')
const Search = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Shippings/Search')

export default [
  {
    path: 'shippings/create',
    name: 'ShippingsCreate',
    component: Single,
    meta: {
      title: 'Adicionar Transportadora',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'shippings',
        action: 'create'
      }
    }
  },
  {
    path: 'shippings/:id',
    name: 'ShippingsEdit',
    component: Single,
    meta: {
      title: 'Editar Transportadora',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'shippings',
        action: 'read'
      }
    }
  },
  {
    path: 'shippings',
    name: 'ShippingsSearch',
    component: Search,
    meta: {
      title: 'Transportadoras',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'shippings',
        action: 'read'
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/dashboard/shippings.js